import BooksActions from './actions'

const initialState = {
  isFetching: false,
  isError: false,
  messageError: null,
  items: [],
  isModalOpen: false,
  searchTerm: '',
  grade: null,
  paginate: {
    page: 1,
    pageCount: 1,
    perPage: 12
  },
  filter: {
    segments: [],
    subjects: [],
    authors: [],
    publishers: [],
    intelligenceScopes: [],
    onuGroups: [],
    onuGoals: [],
    twentyfirstCompetences: [],
    twentyfirstSkills: [],
    oostSubjects: [],
    sels: []
  }
}

function BooksReducer (state = initialState, action) {
  switch (action.type) {
    case BooksActions.BOOKS_FETCH_REQUEST:
      return {
        ...state,
        isFetching: true,
        isError: false,
        messageError: null
      }
    case BooksActions.BOOKS_FETCH_SUCCESS:
      return {
        ...state,
        items: action.payload.data,
        isFetching: false,
        isError: false,
        messageError: null,
        paginate: {
          ...state.paginate,
          pageCount: Math.ceil(action.payload.totalCount / state.paginate.perPage)
        }
      }
    case BooksActions.BOOKS_FETCH_ERROR:
      return {
        ...state,
        isFetching: false,
        isError: true,
        messageError: action.payload
      }
    case BooksActions.BOOKS_MODAL_TOGGLE_VIEW:
      return {
        ...state,
        isModalOpen: !state.isModalOpen
      }
    case BooksActions.BOOKS_MODAL_CHANGE_SEARCH_TERM:
      return {
        ...state,
        searchTerm: action.payload
      }
    case BooksActions.BOOKS_MODAL_CHANGE_ACTIVE_PAGE:
      return {
        ...state,
        paginate: {
          ...state.paginate,
          page: action.payload
        }
      }
    case BooksActions.BOOKS_MODAL_CHANGE_PAGE_COUNT:
      return {
        ...state,
        paginate: {
          ...state.paginate,
          pageCount: action.payload
        }
      }
    case BooksActions.BOOKS_MODAL_CHANGE_FILTER:
      return {
        ...state,
        filter: {
          ...state.filter,
          [action.payload.type]: action.payload.activeIds
        }
      }
    case BooksActions.BOOKS_MODAL_RESET_FILTER:
      return {
        ...state,
        filter: initialState.filter
      }
    case BooksActions.UPDATE_GRADE:
      return {
        ...state,
        grade: action.payload
      }
    default:
      return state
  }
}

export default BooksReducer



// WEBPACK FOOTER //
// ./src/modules/books/reducers.js